import React, { useState, useEffect } from "react";
import "./style.css";
import { Typography, Button, Form, Input } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import Pageloader from "../../../components/loader";
import { validationErrors } from "../../../utils/Helpers";
import * as dispatcherNotesActions from "../../../redux/actions/dispactherNote.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// import { createBatch } from "../../../services/batch.service";
const { Title } = Typography;


const DispatcherNoteAdd = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { postid } = params;
  const [loading, setLoading] = useState(false);
  const [pagename, setpagename] = useState("add");
  const [postData, setPostData] = useState(null);
  
  useEffect(() => {
    if (postid){
      setpagename("Edit");
      dispacthNoteSingle()
    }
  }, [postid])

  const dispacthNoteSingle = async () => {
    try {
      setLoading(true);
      const {data} = await props.dispatcherNotesActions.dispactherNoteSingleAction(postid);
      setPostData(data.data)
    } catch (e) { validationErrors(e) } finally {
      setLoading(false);
    }
  }


  const onFinish = async (values) => {
    try {
      setLoading(true);
      if (pagename === "Edit"){
        await props.dispatcherNotesActions.dispactherNotePatchAction(values, postid).then((res)=>{
          if (res.data.code === 200){navigate("/dispatchernote")}
        });
      } else {
        await props.dispatcherNotesActions.dispactherNotePostAction(values, postid).then((res)=>{
          if (res.data.code === 200){navigate("/dispatchernote")}
        });
      }
    } catch (e) { validationErrors(e) } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>Dispatcher Notes {pagename}</Title>
        <div>
          <Button onClick={() => navigate("/dispatchernote")}><RollbackOutlined /></Button>
        </div>
      </div>
      <div className="p-content">
        {loading ? <Pageloader/>:
          <Form onFinish={onFinish} layout="horizontal">
            <Form.Item
              name={["value"]}
              initialValue={postData && postData.value}
              label={"Dispatcher Note"}
              rules={[{required: true, message: "Please enter Value"}]}
              >
              <Input />
            </Form.Item>
            <Button className="submit" htmlType="submit">Submit</Button>
          </Form>
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dispactherNoteData: state.DispactherNoteReducer.dispactherNoteData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatcherNotesActions: bindActionCreators(dispatcherNotesActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DispatcherNoteAdd);
